import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="bg-gray-100 min-h-screen py-12 px-4 sm:px-6 lg:px-8 mt-[50px]">

      <div className="max-w-3xl mx-auto bg-white shadow-md rounded-lg overflow-hidden">
        <div className="px-4 py-5 sm:p-6">
          <h1 className="text-3xl font-bold text-gray-900 mb-6">Privacy Policy for My Church of Christ</h1>
          <p className="text-sm text-gray-600 mb-4">Last updated: September 23, 2024</p>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Introduction</h2>
            <p className="text-gray-700">
              mychurchofchrist.com ("we" or "us" or "our") respects the privacy of our users ("user" or "you"). 
              This Privacy Policy explains our data practices for both our mobile application My Church of Christ (the "App") 
              and our website mychurchofchrist.com (the "Website").
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Information Collection and Use</h2>
            <p className="text-gray-700">
              We do not collect any personal data or information from you when you use our App.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Log Data</h2>
            <p className="text-gray-700">
              We do not collect any log data or usage information through our App.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Cookies</h2>
            <h3 className="text-lg font-medium text-gray-800 mb-2">Mobile App</h3>
            <p className="text-gray-700 mb-4">
              Our App does not use cookies or any similar tracking technologies.
            </p>
            <h3 className="text-lg font-medium text-gray-800 mb-2">Website</h3>
            <p className="text-gray-700">
              Our Website uses session cookies. These are temporary cookies that are erased when you close your browser. 
              We use session cookies to improve your browsing experience on our Website, but these do not collect any personal information.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Third-Party Services</h2>
            <p className="text-gray-700">
              Our App does not use any third-party services that may collect information used to identify you.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Security</h2>
            <p className="text-gray-700">
              We take reasonable precautions to protect any information we might handle. However, since we do not collect 
              personal information through our App, there is minimal risk of data being compromised through the App.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Changes to This Privacy Policy</h2>
            <p className="text-gray-700">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new 
              Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-800 mb-2">Contact Us</h2>
            <p className="text-gray-700">
              If you have any questions about this Privacy Policy, please contact us at:
            </p>
            <p className="text-blue-600 hover:text-blue-800">
              <a href="mailto:admin@mychurchofchrist.com">admin@mychurchofchrist.com</a>
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;